export default {
  directives: {
    "select-load": {
      bind(el, binding) {
        const select = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        select.addEventListener('scroll', function () {
          const condition = Math.floor(this.scrollHeight - this.scrollTop) <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        })
      }
    },
    
  }
}